import React from "react";

interface Props {

    setModalVisible: (modalVisibleUsuario: boolean) => void;
    modalVisible: boolean;
    empleadosCargados:ClienteCargado[];
    empleadosFallidos:ClienteCargado[];
}

export interface ClienteCargado {
  message: string
  cliente: Cliente
}

export interface Cliente {
  nombre: string
  apellido: string
  correo: string
  password: string
  celular: number
  id_casa: number
  tipo_usuario: number
  avatar: string
  habilitado: string
  fecha_registro: string
  grupo_trabajo: string
}

const ModalEmpleadosFallidos = ({
    modalVisible,
    setModalVisible,
    empleadosCargados,
    empleadosFallidos,
}:Props) => {
    const handleClose = () => {
        setModalVisible(!modalVisible);
    };

    return (
        <div
            className={`relative items-center justify-center ${
                modalVisible ? "flex" : "hidden"
            }`}>
            <div className="fixed bottom-0 left-0 z-20 w-full h-full bg-gray-900 bg-opacity-80 sticky-0 ">
                <div className="flex justify-center px-4 py-8 2xl:container 2xl:mx-auto md:px-28 sm:py-8 ">
                    <div className="relative w-full block justify-center px-4 bg-white rounded-lg  md:w-auto dark:bg-white md:px-14 h-[calc(100vh-10vh)] overflow-y-auto ">
                        <button
                            onClick={handleClose}
                            className="absolute text-gray-800 dark:text-gray-400 top-3 right-3 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800">
                            <svg
                                className="rounded-full hover:bg-gray-600 hover:text-white"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M18 6L6 18"
                                    stroke="currentColor"
                                    strokeWidth="1.66667"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M6 6L18 18"
                                    stroke="currentColor"
                                    strokeWidth="1.66667"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                        <header className="mt-20 text-lg font-medium">
                            Clientes cargados masivamente
                        </header>
                        {empleadosCargados.length > 0 && (
                            <div className="text-base py-7">
                                <span className="font-medium">
                                    Los siguientes clientes fueron cargados
                                    correctamente:
                                </span>
                                <ul className="mt-4">
                                    {empleadosCargados.map(
                                        (empleado, index) => (
                                            <li className="mt-2 text-center border-b" key={index}>
                                                {empleado.cliente.nombre} {empleado.cliente.apellido}
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>
                        )}
                        {empleadosFallidos.length > 0 && (
                            <div className="pb-4 text-base">
                                <span className="font-medium">
                                    Se encontraron errores en los siguientes
                                    clientes:{" "}
                                </span>
                                <ul className="mt-4">
                                    {empleadosFallidos.map(
                                        (empleado, index) => (
                                            <li className="mt-2 text-center border-b" key={index}>
                                              {empleado.cliente.nombre} {empleado.cliente.apellido} error: <span className="font-medium">{empleado.message} </span>
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>
                        )}
                        <button
                            onClick={handleClose}
                            className="flex items-center justify-center w-full p-3 mx-auto mb-5 border rounded-lg hover:scale-105 border-blue-bluecorner">
                            Aceptar y cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalEmpleadosFallidos;
